//------------------------------------------------------------------------------
//     This code was generated by a tool.
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
//------------------------------------------------------------------------------  
enum ReservationEventType {
  Miscellaneous = 0,

  CheckIn = 1,

  CheckOut = 2,

  LandOwnerConfirmation = 3,

  ManualLandOwnerConfirmationAttempt = 4,

  ReservationModified = 5,

  MemberFeedback = 6,

  LandownerFeedback = 7,

}

export default ReservationEventType;